import ImageOptimizer from '@/components/image-optimizer';
import { ReactNode } from 'react';

interface Props {
  iconPath: string;
  title: string;
  children: ReactNode;
}
export default function AcademyBasicCard({ iconPath, title, children }: Props) {
  return (
    <div className="desktop:gap-4 desktop:px-[28px] desktop:py-6 flex h-auto flex-col gap-4 rounded-xl bg-gray-50 px-[18px] py-6">
      <div className="flex items-center gap-1">
        <ImageOptimizer src={iconPath} alt="icon" width={20} height={20} />
        <span className="typo-20 text-level-1 font-bold">{title}</span>
      </div>
      {children}
    </div>
  );
}
